(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/terms-integrity-react/assets/react/shared-components/use-get-cms-data-folder.js') >= 0) return;  svs.modules.push('/modules/terms-integrity-react/assets/react/shared-components/use-get-cms-data-folder.js');

'use strict';

const {
  logger
} = svs.termsIntegrity;
const TirService = svs.termsIntegrity.sharedComponents.TirService;
const useGetCmsDataFolder = dataGid => {
  const {
    useState,
    useEffect
  } = React;
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dataError, setDataError] = useState(false);
  useEffect(() => {
    const getData = async () => {
      try {
        setLoading(true);
        const {
          error,
          totalCount,
          result
        } = await TirService.getCmsDataFolderAsync(dataGid);
        logger.debug("useGetCmsDataFolder: error: ".concat(error, ", totalCount: ").concat(totalCount, ", result: ").concat(result));
        logger.debug(result);
        setLoading(false);
        if (error) {
          setDataError(true);
        } else if (result && result.length > 0) {
          setData(result);
        }
      } catch (error) {
        setLoading(false);
        setDataError(true);
        logger.debug("useGetCmsDataFolder error:".concat(error));
      }
    };
    getData();
  }, [dataGid]);
  return {
    data,
    loading,
    dataError
  };
};
svs.termsIntegrity.sharedComponents.useGetCmsDataFolder = useGetCmsDataFolder;

 })(window);